import { formatPrice, restaurant } from "../data/siteData";

const money = (v) => formatPrice(Math.round(v * 100) / 100);

export const extrasText = (item) => {
  const parts = [item.meat ? `${item.meat} viande` : "", item.veg ? `${item.veg} légume` : ""].filter(Boolean);
  if (!parts.length) return "";
  return `suppléments${item.qty > 1 ? " par pizza" : ""} : ${parts.join(", ")}`;
};

const lineText = (item) => {
  const extras = extrasText(item);
  return `- ${item.qty} × ${item.product.name}${extras ? ` (${extras})` : ""} : ${money(item.total)}`;
};

export const buildOrderMessage = ({ items, total, pizzaCount, details }) => {
  const rows = [
    "Bonjour CAP SUD, nouvelle commande à préparer !",
    "",
    `Client : ${details.name}`,
    `Téléphone : ${details.phone}`,
    "",
    "Commande :",
    ...items.map(lineText),
    "",
    `Total : ${money(total)}`,
    `Retrait souhaité : ${details.day.full} à ${details.slot.label}`,
  ];
  if (pizzaCount > 0) rows.push(`Canette${pizzaCount > 1 ? "s" : ""} offerte${pizzaCount > 1 ? "s" : ""} : ${pizzaCount} (offre pizza à emporter)`);
  if (details.notes) rows.push(`Remarques : ${details.notes}`);
  rows.push("", "Merci de confirmer la disponibilité de cette commande.");
  return rows.join("\n");
};

export const whatsappUrl = (message) => `https://wa.me/${restaurant.orderPhone.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;

export const smsUrl = (message) => `sms:${restaurant.orderPhone}?&body=${encodeURIComponent(message)}`;
